export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_categoryOptionNo') || '代码',
    field: 'categoryOptionNo',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_categoryOptionNameEn') || '英文名称',
    field: 'categoryOptionNameEn',
    minWidth: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_categoryOptionName') || '中文名称',
    field: 'categoryOptionName',
    minWidth: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_categoryOptionDesc') || '中文描述',
    field: 'categoryOptionDesc',
    minWidth: 340,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_categoryOptionDescEn') || '英文描述',
    field: 'categoryOptionDescEn',
    minWidth: 340,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
]
